// @ts-nocheck
import * as React from "react";

const QuoteMark: React.FC = () => {
    return (
        <svg
            width="44"
            height="38"
            viewBox="0 0 44 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
        >
            <path
                d="M0 38V19.0757L9.79402 0L18.8571 0.151394L11.9867 19.0757H17.6877V38H0ZM25.1429 38V19.0757L34.7907 0L44 0.151394L36.9834 19.0757H42.8306V38H25.1429Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(QuoteMark);
